<template>
  <v-main style="background-color: #b0bec5" >
    <v-container fluid style="max-width: 400px; height: 100%;" class="pa-0 d-flex">
      <vue-headful title="Mein Dashboard" description="Dashboard your Life"/>
<!--      <v-row v-if="!app.user.initialized">-->
<!--        <v-col class="pa-0">-->
<!--          <user-data></user-data>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--      <v-row v-else>-->
        <div class="d-flex pa-0" style="width: 100%;">
          <v-col class="mt-3 d-flex align-stretch pa-0">
  <!--          <h1 class="display-1 text-center">Servus!</h1>-->
            <InitializeUser class="mx-3" v-if="!initialized" @done="initialized=true"></InitializeUser>
            <Dashboard style="width: 100%; height: 100%" v-else/>
          </v-col>
      </div>
    </v-container>
  </v-main>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Vue from "vue";
import UserData from "@/views/UserData";
import CenterContainer from "@/components/CenterContainer";
import Activities from "@/components/Activities";
import InitializeUser from "@/views/InitializeUser";
import Dashboard from "@/components/Dashboard";
import UserLib from "@/components/UserLib";

export default {
  name: 'Lobby',
  components: {InitializeUser, CenterContainer, UserData, Dashboard },
  data: () => ({
    initialized:true,
  }),
  mounted() {
    if (this.$app.desktop)
      this.$app.show_drawer = true;
    this.$nextTick(this.check_session) // and if not, open user data form
  },
  beforeRouteUpdate(to, from, next) {
    //console.log("lobbyRouteChanged", to);
    this.$events.$emit("lobbyRouteChanged", to);
    next();
  },
  methods: {
    async check_session() {
      this.exit_if_not_logged_in();
      var user=await this.$backend.check_session();
      this.$app.save("user", user);
      this.exit_if_not_logged_in();
      this.check_initialized();
    },
    async check_initialized() {
      if (!this.$app.is_logged_in)
        return;
      if (this.$store.state.user.product == UserLib.ProductSalesTeam)
        this.initialized=true;
      else
        this.initialized=this.$store.state.user.initialized;
    },
    exit_if_not_logged_in() {
      if (!this.$app.is_logged_in) {
        this.$store.commit("set", {key: "intern", value: false});
        if (this.$route.path != "/")
          this.$router.replace("/");
        return;
      }
      this.$store.commit("set", {key: "intern", value: true});
    }
  },
  computed: {
    app() {
      return this.$app;
    }
  },
  watch: {
    // is_logged_in(n, o) {
    //     console.log("is_logged_in: " + n);
    //     if (!n) {
    //         this.$router.go(-1000);
    //         this.$router.replace("/")
    //     }
    // }
  }
}
</script>

<style>
.rb {
  border: red 1px solid;
}

.full_width {
  width: 100%;
}
</style>